import { ACTIONABLE_FOLLOW_UPS_MARKER } from '@atlassian/conversation-assistant-content-transformer/utils/actionable-follow-ups';
import { type StreamResponse } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY } from './ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY';
import { extractMarkdownContent } from './extractMarkdownContent';

/**
 * Extract the actionable follow-ups payload from a message and write it into
 * `markdownData`. The marker (`◈`) has no end tag — everything after it to the
 * end of the message is the follow-ups payload (open-ended boundary).
 *
 * Shared by the final-response path (`processStreamResponseMarkdown`) and the
 * conversation-history path (`processConversationMessages`) so that messages
 * render identically whether they arrive via streaming or are loaded from
 * history. Without this on the history path the raw `◈<followup>…</followup>`
 * marker would render literally when reopening a past conversation.
 */
export const extractActionableFollowUpsMarkdownData = ({
	streamMessage,
	markdownData,
}: {
	streamMessage: StreamResponse;
	markdownData: Record<string, string>;
}): StreamResponse => {
	const followUpsMsg = extractMarkdownContent({
		streamMessage,
		boundaryStart: ACTIONABLE_FOLLOW_UPS_MARKER,
		boundaryEnd: '',
		replacementContent: `\n\n[^${ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}^]\n\n`,
	});
	followUpsMsg.boundaryContents.forEach((content, index) => {
		markdownData[`${ACTIONABLE_FOLLOW_UPS_COMPONENT_KEY}-${index}`] = content;
	});

	return followUpsMsg.processedStreamMessage as StreamResponse;
};
